export default __webpack_public_path__ + "static/media/logo.cd9ce6b4.svg";